import React, { useState } from 'react';
import './QuoteModal.css';

function QuoteModal({ product, onClose, onSubmit }) {
  const [formData, setFormData] = useState({
    vehicleRegistration: '',
    sumInsured: '',
    capacity: '',
    excessProtector: false,
    pvt: false
  });
  const [isGenerating, setIsGenerating] = useState(false);

  const isPSVChauffeur = product.name === 'PSV Chauffeur Driven';
  const isTukTukCommercial = product.name === 'Tuk Tuk Commercial';
  const isTukTukPSV = product.name === 'Tuk Tuk PSV';
  const isTSV = product.name === 'Tour Service Vehicle';
  const isSpecialTypes = product.name === 'Special Types Vehicles';
  const isSelfDrive = product.name === 'PSV Self Drive';
  const isSchoolBus = product.name === 'School Bus';
  const isPSVMatatu = product.name === 'PSV Matatu';
  const isPSVBus = product.name === 'PSV Bus';
  const isMotorcyclePrivate = product.name === 'Motorcycle Private';
  const isMotorcycleBodaBoda = product.name === 'Motor Cycle BodaBoda';
  const isInstitutional = product.name === 'Motor Commercial Institutional';
  const isMotorPrivate = product.name === 'Motor Private';
  const isOwnGoods = product.name === 'Motor Commercial Own Goods';
  const isGeneralCartage = product.name === 'Motor Commercial General Cartage';
  const isAmbulanceFirefighters = product.name === 'Ambulance and Firefighters';
  const isMotorAssetMatatu = product.name === 'Motor Asset Matatu';
  const isMotorAssetBus = product.name === 'Motor Asset Bus';

  // Products that should show excess protector
  const showExcessProtector = isMotorPrivate || isOwnGoods || isGeneralCartage || isTSV || isPSVMatatu || isPSVBus || isMotorAssetMatatu || isMotorAssetBus;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsGenerating(true);
    await onSubmit(formData);
    setIsGenerating(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>&times;</button>
        
        <div className="modal-header">
          <h2>{product.name}</h2>
          <p className="modal-subtitle">Fill in the details to get your quote</p>
        </div>

        <form onSubmit={handleSubmit} className="quote-form">
          <div className="form-group">
            <label htmlFor="vehicleRegistration">
              Vehicle Registration Number <span className="required">*</span>
            </label>
            <input
              type="text"
              id="vehicleRegistration"
              name="vehicleRegistration"
              value={formData.vehicleRegistration}
              onChange={handleChange}
              placeholder="e.g., KAA 123A"
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="sumInsured">
              Sum Insured (KES) <span className="required">*</span>
            </label>
            <input
              type="number"
              id="sumInsured"
              name="sumInsured"
              value={formData.sumInsured}
              onChange={handleChange}
              placeholder="e.g., 1000000"
              required
              min="0"
              step="1000"
              className="form-input"
            />
          </div>

          {(isPSVChauffeur || isTukTukPSV || isTSV || isSelfDrive || isSchoolBus || isInstitutional || isAmbulanceFirefighters) && !isSpecialTypes && (
            <div className="form-group">
              <label htmlFor="capacity">
                Capacity {!isAmbulanceFirefighters && <span className="required">*</span>}
              </label>
              <input
                type="number"
                id="capacity"
                name="capacity"
                value={formData.capacity}
                onChange={handleChange}
                placeholder="e.g., 7"
                required={!isAmbulanceFirefighters}
                min="1"
                className="form-input"
              />
            </div>
          )}

          {showExcessProtector && (
            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="excessProtector"
                  checked={formData.excessProtector}
                  onChange={handleChange}
                  className="form-checkbox"
                />
                <span className="checkbox-text">
                  Add Excess Protector
                  <small>{(isPSVMatatu || isPSVBus || isMotorAssetMatatu || isMotorAssetBus) ? '0.50% of premium' : isPSVChauffeur ? '0.25% of premium' : 'Additional 0.25% of premium'}</small>
                </span>
              </label>
            </div>
          )}

          {(isPSVChauffeur || isPSVMatatu || isPSVBus || isMotorAssetMatatu || isMotorAssetBus) && (
            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="pvt"
                  checked={formData.pvt}
                  onChange={handleChange}
                  className="form-checkbox"
                />
                <span className="checkbox-text">
                  Add PVT
                  <small>0.45% of premium</small>
                </span>
              </label>
            </div>
          )}

          <div className="form-actions">
            <button type="button" onClick={onClose} className="btn-secondary">
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={isGenerating}>
              {isGenerating ? (
                <>
                  <span className="spinner"></span>
                  Generating...
                </>
              ) : (
                'Generate Quote'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default QuoteModal;
